export default {
  init() {
    if ($('.stats').length) {
      loopStats();

      $(document).on('scroll', function () {
        loopStats();
      });
    }

    function loopStats() {
      $('.stats__item').not('.stats__item--counted').each(function () {
        isInViewPort(this) && counter($(this));
      });
    }

    function counter(element) {
      var number = $('h2', element);
      var endNumber = element.data('stats-number');
  
      element.addClass('stats__item--counted');
  
      setTimeout(function () {
        $({ countNum: number.text()}).animate({
          countNum: endNumber,
        }, {
          duration: 800,
          easing:'linear',
          step: function() {
            number.text(new Intl.NumberFormat(document.documentElement.lang).format(Math.floor(this.countNum)));
          },
          complete: function() {
            number.text(new Intl.NumberFormat(document.documentElement.lang).format(this.countNum));
          },
        });
      }, 150);
    }
    
    function isInViewPort(element) {
      var elementTop = $(element).offset().top;
      var elementBottom = elementTop + ($(element).outerHeight());
      var viewportTop = $(window).scrollTop() - 200;
      var viewportBottom = viewportTop + $(window).height();
  
      return elementBottom > viewportTop && elementTop < viewportBottom;
    }
  },
};
